type SectionTapProps = {
    datatap?: any;
    optionActive:string;
    onsearchFilter?: (e: string) => any;
  };
  
  const SectionTap = ({ datatap, onsearchFilter, optionActive }: SectionTapProps) => {

    return (
      <section className="flex">
        {datatap?.map((itemTap: any) => (
          <div
            key={itemTap.name}
            className={
                itemTap.name.includes(optionActive)
                ? `${itemTap.class} tap-actve `
                : itemTap.class
            }
            onClick={() => onsearchFilter?.(itemTap.name)}
          >
            {itemTap.name}
          </div>
        ))}
      </section>
    );
  };
  
  export default SectionTap;